import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import RestoreIcon from '@material-ui/icons/Restore';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import {isMobile, browserName, osName, OsTypes } from 'react-device-detect';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip } from 'antd';
import DehazeIcon from '@material-ui/icons/Dehaze';

const styles = {
  root: {
    width: '100%',
    height: '30',
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#898A8A',
    color: '#FF9900',
   
    
  },
  button: {
    color: '#fff',
  },
  buttonat: {
    color: '#FF9900',
  },
};

class Foottermobil extends React.Component {
  state = {
    value: 0,

    device:'',
    osName:'',
    browsername:'',
    datelogin:'',
    timelogin:'',
    sizem:'',
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

   handleopen = () => {
   this.props.handleDrawerToggle();
  };

  logout() {
    //   localStorage.removeItem(('admin_type'))
     //  localStorage.removeItem(('nameuser'))
      localStorage.clear();
  
      setTimeout(() => {
        window.location.href = '/login'
      }, 1000);
     // this.setState({ admin_type: 'public' }
      message.success("ออกจากระบบแล้ว")
    }

  componentDidMount() {

    if (isMobile) {
      const moment = require('moment');
      const  now = new Date();
      const formattedDate =moment(now).format('YYYY-MM-DD');
      const formattedtime =moment(now).format('HH:mm');
     // return <div> This content is available only on mobile</div>
      console.log('mobile')
      console.log(browserName)
      console.log(osName)
      console.log(formattedDate)

     this.setState({
      device: 'mobile',
      sizem:'250',
      browsername: browserName,
      datelogin : formattedDate,
      timelogin : formattedtime,
      osName : osName,
    });

    }else{
   
       console.log('browser')
       console.log(browserName)
       console.log(osName)
      const moment = require('moment');
      const  now = new Date();
      const formattedDate =moment(now).format('YYYY-MM-DD HH:mm:ss');
      const formattedtime =moment(now).format('HH:mm');

      console.log(formattedDate)

      this.setState({
        device: 'browser',
        sizem:'750',
        browsername: browserName,
        datelogin : formattedDate,
        timelogin : formattedtime,
        osName : osName,
      });
    }


  }

  render() {
    const { classes } = this.props;
    const { value } = this.state;

    return (
        <>
        {this.state.device === 'mobile' ?<>
       
         <BottomNavigation
        value={value}
        onChange={this.handleChange}
        showLabels
        className={classes.root}
        activeColor="#00aea2"
        inactiveColor="#95a5a6"
      >
        <BottomNavigationAction  className={classes.button} label="หน้าหลัก"  component={Link}  to="/welcome" icon={<RestoreIcon />} />
        <BottomNavigationAction className={classes.button} onClick={this.handleopen} label="เมนู"   icon={<DehazeIcon />} />
        <BottomNavigationAction className={classes.button} onClick={this.logout} label="ออกจากระบบ" icon={<LocationOnIcon />} />
      </BottomNavigation>
     
        </>:<></>}
        
        </>
     
    );
  }
}

Foottermobil.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Foottermobil);